// import React from "react";

// function Footer() {
//   return (
//     <footer className="bg-primary-color text-black py-6">
//       <div className="container mx-auto px-4 lg:px-8 mr-auto ml-auto">
//         {/* Footer content for large screens */}
//         <div className="hidden lg:flex lg:items-center lg:justify-between">
//           {/* Left box */}
//           <div className="flex items-center ml-auto mr-auto">
//             <div className="mr-6">
//               <h4 className="text-lg font-semibold text-gray-900">
//                 Contact Us
//               </h4>
//               <p className="text-gray-900">
//                 Phone: <a href="tel:+918879238386">+91 88792 38386</a> <br />
//                 Email:{" "}
//                 <a href="mailto:marketing.brandflow@gmail.com">
//                   marketing.brandflow@gmail.com
//                 </a>
//               </p>
//               {/* Social media icons */}
//               <div className="mt-4 flex space-x-4 justify-center">
//                 {/* <a href="#" className="text-white hover:text-gray-400">
//                   <i className="fab fa-twitter"></i>
//                 </a>
//                 <a href="#" className="text-white hover:text-gray-400">
//                   <i className="fab fa-facebook"></i>
//                 </a> */}
//                 <a
//                   href="https://www.instagram.com/brandflow.marketing/"
//                   target="_blank"
//                   className="text-white hover:text-gray-400"
//                 >
//                   <i className="fab fa-instagram"></i>
//                 </a>
//               </div>
//             </div>
//           </div>
//           {/* Logo */}
//           <div className="ml-auto mr-auto">
//             <img src="FullLogo.png" alt="Logo" className="h-60" />
//           </div>
//           {/* Right box */}
//           <div className="flex items-center ml-auto mr-auto">
//             {/* <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSckqSdkz-Dsact3I9YOmy-ulvvg6IKjy3R_SjqVO6RSVZunkg/viewform?embedded=true" width="640" height="1455" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe> */}
//             <iframe
//               src="https://docs.google.com/forms/d/e/1FAIpQLSckqSdkz-Dsact3I9YOmy-ulvvg6IKjy3R_SjqVO6RSVZunkg/viewform?embedded=true"
//               width="300"
//               height="300"
//               frameborder="0"
//               marginheight="0"
//               marginwidth="0"
//               title="Google Form"
//             >
//               Loading…
//             </iframe>
//           </div>
//         </div>

//         {/* Footer content for small screens */}
//         <div className="lg:hidden mt-6">
//           <div>
//             <img src="FullLogo.png" alt="Logo" className="h-60 mx-auto" />
//           </div>
//           <div className="mt-6">
//             <h4 className="text-lg text-gray-900 font-semibold text-center">
//               Contact Us
//             </h4>
//             <p className="text-gray-900 text-center">
//               Phone: <a href="tel:+918850450922">+91 88504 50922</a> <br />
//               Email:{" "}
//               <a href="mailto:marketing.brandflow@gmail.com">
//                 marketing.brandflow@gmail.com
//               </a>
//             </p>
//             {/* Social media icons */}
//             <div className="mt-4 flex justify-center space-x-4">
//               {/* <a href="#" className="text-white hover:text-gray-400">
//                 <i className="fab fa-twitter"></i>
//               </a>
//               <a href="#" className="text-white hover:text-gray-400">
//                 <i className="fab fa-facebook"></i>
//               </a> */}
//               <a
//                 href="https://www.instagram.com/brandflow.marketing/"
//                 target="_blank"
//                 className="text-white hover:text-gray-400"
//               >
//                 <i className="fab fa-instagram"></i>
//               </a>
//             </div>
//           </div>
//           <div className="mt-6">
//             <iframe
//               src="https://docs.google.com/forms/d/e/1FAIpQLSckqSdkz-Dsact3I9YOmy-ulvvg6IKjy3R_SjqVO6RSVZunkg/viewform?embedded=true"
//               width="100%"
//               height="500"
//               frameborder="0"
//               marginheight="0"
//               marginwidth="0"
//               title="Google Form"
//             >
//               Loading…
//             </iframe>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }

// export default Footer;

// import React from "react";
// import { FaPhoneAlt, FaEnvelope, FaInstagram } from "react-icons/fa";

// function Footer() {
//   return (
//     <footer className="relative text-white">
//       {/* Background */}
//       <div className="absolute inset-0 bg-primary-color"></div>

//       {/* Glass overlay */}
//       <div className="absolute inset-0 bg-white/5 backdrop-blur-md border-t border-white/10"></div>

//       <div className="relative z-10 container mx-auto px-6 py-14">
//         {/* GRID */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center md:text-left">
//           {/* LEFT */}
//           <div className="space-y-5">
//             <h3 className="text-2xl font-semibold text-white">Contact Us</h3>

//             <p className="flex items-center justify-center md:justify-start gap-3 text-gray-300">
//               <FaPhoneAlt className="text-secondary-color text-xl" />
//               <a
//                 href="tel:+918879238386"
//                 className="hover:text-white transition"
//               >
//                 +91 88792 38386
//               </a>
//             </p>

//             <p className="flex items-center justify-center md:justify-start gap-3 text-gray-300">
//               <FaEnvelope className="text-secondary-color text-xl" />
//               <a
//                 href="mailto:marketing.brandflow@gmail.com"
//                 className="hover:text-white transition"
//               >
//                 marketing.brandflow@gmail.com
//               </a>
//             </p>

//             {/* Instagram Icon */}
//             <a
//               href="https://www.instagram.com/brandflow.marketing/"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="inline-flex items-center justify-center w-12 h-12 rounded-full
//                          bg-secondary-color hover:bg-secondary-color
//                          text-gray-300 hover:text-white text-2xl
//                          transition-all mx-auto md:mx-0"
//             >
//               <FaInstagram />
//             </a>
//           </div>

//           {/* CENTER LOGO */}
//           <div className="flex justify-center">
//             <img
//               src="FullLogo.png"
//               alt="Brandflow Logo"
//               className="h-52 hover:scale-105 transition duration-300"
//             />
//           </div>

//           {/* RIGHT - GOOGLE FORM */}
//           <div className="flex justify-center md:justify-end">
//             <div className="rounded-2xl overflow-hidden bg-white/10 border border-white/20 backdrop-blur-xl shadow-lg">
//               <iframe
//                 src="https://docs.google.com/forms/d/e/1FAIpQLSckqSdkz-Dsact3I9YOmy-ulvvg6IKjy3R_SjqVO6RSVZunkg/viewform?embedded=true"
//                 width="320"
//                 height="320"
//                 frameBorder="0"
//                 marginHeight="0"
//                 marginWidth="0"
//                 title="Google Form"
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }

// export default Footer;

// import React from "react";
// import {
//   FaPhoneAlt,
//   FaEnvelope,
//   FaInstagram,
//   FaLinkedin,
// } from "react-icons/fa";

// function Footer() {
//   return (
//     <footer className="relative overflow-hidden pt-20 pb-10">
//       {/* === BACKGROUND LAYERS === */}
//       <div className="absolute inset-0 bg-primary-color"></div>

//       {/* Gradient Glow */}
//       <div className="absolute inset-0 bg-gradient-to-br from-primary-color/10 via-transparent to-secondary-color/10 opacity-70 blur-3xl"></div>

//       {/* Top Glass Layer */}
//       <div className="absolute inset-0 bg-white/5 backdrop-blur-xl border-t border-white/10"></div>

//       {/* === CONTENT === */}
//       <div className="relative z-10 container mx-auto px-6 lg:px-14">
//         {/* MAIN GRID */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-16 text-white">
//           {/* === COLUMN 1: BRAND === */}
//           <div className="flex flex-col items-center md:items-start space-y-5">
//             <img
//               src="FullLogo.png"
//               alt="BrandFlow"
//               className="h-40 md:h-48 hover:scale-105 transition duration-300"
//             />

//             <p className="text-gray-300 text-sm md:text-base max-w-xs text-center md:text-left leading-relaxed">
//               Elevating brands with modern strategy, visual identity, market
//               positioning, and high-performance campaigns — all designed to make
//               your brand unforgettable.
//             </p>
//           </div>

//           {/* === COLUMN 2: QUICK LINKS === */}
//           <div className="flex flex-col items-center md:items-start space-y-4">
//             <h3 className="text-lg font-semibold tracking-wide">Navigation</h3>

//             <div className="space-y-2 text-center md:text-left">
//               {["Home", "Services", "About", "Gallery", "Contact Us"].map(
//                 (item, index) => (
//                   <a
//                     key={index}
//                     href={`${item.toLowerCase()}`}
//                     className="block text-gray-400 hover:text-white transition
//                                hover:translate-x-1 duration-300"
//                   >
//                     {item}
//                   </a>
//                 )
//               )}
//             </div>
//           </div>

//           {/* === COLUMN 3: CONTACT === */}
//           <div className="flex flex-col items-center md:items-start space-y-4">
//             <h3 className="text-lg font-semibold tracking-wide">Contact Us</h3>

//             <p className="flex items-center space-x-3 text-gray-300">
//               <FaPhoneAlt className="text-primary-color" />
//               <a
//                 href="tel:+918879238386"
//                 className="hover:text-white transition"
//               >
//                 +91 88792 38386
//               </a>
//             </p>

//             <p className="flex items-center space-x-3 text-gray-300">
//               <FaEnvelope className="text-primary-color" />
//               <a
//                 href="mailto:marketing.brandflow@gmail.com"
//                 className="hover:text-white transition"
//               >
//                 marketing.brandflow@gmail.com
//               </a>
//             </p>

//             {/* Social Icons */}
//             <div className="flex space-x-5 pt-2">
//               <a
//                 href="https://www.instagram.com/brandflow.marketing/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="w-11 h-11 rounded-full bg-white/10 backdrop-blur-lg
//                            border border-white/20 flex items-center justify-center
//                            text-xl text-white hover:text-black hover:bg-primary-color
//                            transition-all duration-300 shadow"
//               >
//                 <FaInstagram />
//               </a>

//               <a
//                 href="https://www.linkedin.com"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="w-11 h-11 rounded-full bg-white/10 backdrop-blur-lg
//                            border border-white/20 flex items-center justify-center
//                            text-xl text-white hover:text-black hover:bg-primary-color
//                            transition-all duration-300 shadow"
//               >
//                 <FaLinkedin />
//               </a>
//             </div>
//           </div>
//         </div>

//         {/* === FOOTER BOTTOM === */}
//         <div className="mt-20 pt-8 border-t border-white/10 text-center text-gray-400 text-sm">
//           © {new Date().getFullYear()} BrandFlow. All Rights Reserved.
//         </div>
//       </div>
//     </footer>
//   );
// }

// export default Footer;

import React from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaInstagram,
  FaLocationArrow,
} from "react-icons/fa";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="relative w-full bg-primary-color text-white pt-20 pb-10 overflow-hidden">
      {/* Top Glow Line */}
      <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-secondary-color to-transparent opacity-60"></div>

      {/* Animated Waves BG */}
      <div className="absolute bottom-0 left-0 w-full h-[120%] opacity-[0.12] pointer-events-none">
        <svg
          className="w-full h-full animate-pulse"
          viewBox="0 0 1440 690"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <path
            fill="#6c47ff"
            d="M0,192L60,170.7C120,149,240,107,360,117.3C480,128,600,192,720,218.7C840,245,960,235,1080,229.3C1200,224,1320,224,1380,224L1440,224L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"
          ></path>
        </svg>
      </div>

      {/* Content Container */}
      <div className="relative max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-12 z-20">
        {/* Branding */}
        <div>
          <h2 className="text-3xl font-semibold tracking-wide mb-4">
            <span className="bg-gradient-to-r from-white to-secondary-color text-transparent bg-clip-text">
              Brandflow
            </span>
          </h2>
          <p className="text-gray-300 leading-relaxed max-w-sm">
            A premium digital marketing agency focused on branding, identity,
            web presence, and business growth through creative strategies.
          </p>
        </div>

        {/* Glass Panel – Quick Links */}
        <div className="backdrop-blur-xl bg-white/5 border border-white/10 p-6 rounded-2xl shadow-2xl">
          <h3 className="text-xl font-semibold mb-3">Quick Links</h3>
          <ul className="space-y-2">
            <Link to="/">
              <li className="hover:text-secondary-color transition cursor-pointer">
                Home
              </li>
            </Link>
            <Link to="/about">
              <li className="hover:text-secondary-color transition cursor-pointer">
                About Us
              </li>
            </Link>
            <Link to="/gallery">
              <li className="hover:text-secondary-color transition cursor-pointer">
                Gallery
              </li>
            </Link>
            <Link to="/contact">
              <li className="hover:text-secondary-color transition cursor-pointer">
                Contact Us
              </li>
            </Link>
          </ul>
        </div>

        {/* Glass Panel – Contact */}
        <div className="backdrop-blur-xl bg-white/5 border border-white/10 p-6 rounded-2xl shadow-2xl">
          <h3 className="text-xl font-semibold mb-4">Contact</h3>

          {/* Phone */}
          <div className="flex items-center gap-4 mb-4">
            <FaPhoneAlt size={20} className="text-secondary-color" />
            <a href="tel:+918879238386">
              <span className="text-gray-200">+91 88792 38386</span>
            </a>
          </div>

          {/* Email */}
          <div className="flex items-center gap-4 mb-4">
            <FaEnvelope size={20} className="text-secondary-color" />
            <a href="mailto:marketing.brandflow@gmail.com">
              <span className="text-gray-200">
                marketing.brandflow@gmail.com
              </span>
            </a>
          </div>

          {/* Instagram */}
          <div className="flex items-center gap-4 mb-4">
            <FaInstagram size={22} className="text-secondary-color" />
            <a
              href="https://www.instagram.com/brandflow.marketing/"
              target="_blank"
            >
              <span className="text-gray-200">@brandflow.marketing</span>
            </a>
          </div>

          {/* Location */}
          {/* <div className="flex items-center gap-4">
            <FaLocationArrow size={20} className="text-secondary-color" />
            <span className="text-gray-200">Mumbai, India</span>
          </div> */}
        </div>
      </div>

      {/* Bottom Line */}
      <p className="text-center mt-14 text-gray-300 text-sm">
        © Copyright {new Date().getFullYear()}. Brandflow - All Rights Reserved.
      </p>
    </footer>
  );
}
